import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTimeFormatPreferencePipe } from 'app/shared/pipes/date-time-format-preference/date-time-format-preference.pipe';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';

export type TimeRangeSelectorItem = { id: any, name: string, active: boolean, timestamp?: number };
@Component({
    selector: 'app-time-range-selector',
    templateUrl: './time-range-selector.component.html',
    styleUrls: ['./time-range-selector.component.scss'],
    standalone: false
})
export class TimeRangeSelectorComponent {

  @Input() items: TimeRangeSelectorItem[];
  @Input() title: string;
  @Input() showCheckbox = false;
  @Input() checkboxTitle: string;
  @Output() activeChanged: EventEmitter<TimeRangeSelectorItem> = new EventEmitter();
  @Output() checkBoxValueChanged = new EventEmitter();
  @Input() left: boolean;
  @Input() marginLeft: number;
  @Input() exportedData: any;

  public checkboxState = true;

  constructor(
		private translateService: TranslateService,
		private dateTimeFormatPreferencePipe: DateTimeFormatPreferencePipe,
    public tz: TimezoneService
	) { }

  public setActive(item) {
    this.items.forEach(element => {
      element.active = element.id === item.id;
    });
    this.activeChanged.emit(item);
  }

  public boxValueChanged(event) {
    this.checkBoxValueChanged.emit(this.checkboxState);
  }

}
